module.exports = {"321182001":"三茅街道","321182101":"新坝镇","321182102":"油坊镇","321182103":"八桥镇","321182104":"西来桥镇","321182400":"经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321182.json
// module id = 852
// module chunks = 0